export default "__VITE_PUBLIC_ASSET__a0574e12__"